import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	helpText: {
		id: 'servicedesk-widget-settings.common.embed-code-v2.help-text',
		defaultMessage:
			'Use this code to embed the widget on your website. You only need to embed your widget once – changes you save are automatically applied.',
		description:
			'Help text displayed under the label and embed code box, explaining what the embed code is for',
	},
	copyCodeButtonText: {
		id: 'servicedesk-widget-settings.common.embed-code-v2.copy-code-button-text',
		defaultMessage: 'Copy',
		description:
			'Text for the copy button, which when clicked copies the embed code to the clipboard.',
	},
	codeCopiedConfirmationText: {
		id: 'servicedesk-widget-settings.common.embed-code-v2.code-copied-confirmation-text',
		defaultMessage: 'Copied!',
		description:
			'Confirmation text for the copy button, once code is copied successfully to the clipboard, it shows as a popup message.',
	},
	codeEmptyMessage: {
		id: 'servicedesk-widget-settings.common.embed-code-v2.code-empty-message',
		defaultMessage: 'Customize your widget and save your changes to generate the embed code',
		description: 'Text displayed when there is no embed code to copy. This is a placeholder text.',
	},
});
